import clientToServer from './clientToServer';
import clientToQuery from './clientToQuery';
import segmentsToClient from './segmentsToClient';

export default {
  clientToServer,
  clientToQuery,
  segmentsToClient,
};
